var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('z-header',{attrs:{"title":_vm.title,"actions":_vm.actions}}),_c('Form',{ref:"formRef",attrs:{"data":_vm.entry},on:{"save":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }